// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_solution_alternatives.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-499 SOL-03: lightweight solution alternatives, the human decision on
 * them, and evidence-linked gaps. Alternatives and decisions are append-only;
 * a decision never writes a Solution Concept revision.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionDecision
 */ export class CaptureSolutionDecision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * selected | rejected
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * Required: why the team chose or rejected the option.
   *
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 5;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionDecision, "runtime", proto3);
_define_property(CaptureSolutionDecision, "typeName", "mono.projectdata.v1.CaptureSolutionDecision");
_define_property(CaptureSolutionDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionAlternative
 */ export class CaptureSolutionAlternative extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionAlternative().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionAlternative().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionAlternative().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionAlternative, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string narrative = 3;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string advantages = 4;
   */ _define_property(this, "advantages", ""), /**
   * @generated from field: string concerns = 5;
   */ _define_property(this, "concerns", ""), /**
   * @generated from field: string assumptions = 6;
   */ _define_property(this, "assumptions", ""), /**
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * Derived from the latest decision: undecided | selected | rejected | superseded
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * Newest first. Retained in full, including rejections.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionDecision decisions = 10;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionAlternative, "runtime", proto3);
_define_property(CaptureSolutionAlternative, "typeName", "mono.projectdata.v1.CaptureSolutionAlternative");
_define_property(CaptureSolutionAlternative, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "advantages",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "concerns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "decisions",
            kind: "message",
            T: CaptureSolutionDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionGapEvidence
 */ export class CaptureSolutionGapEvidence extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionGapEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionGapEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionGapEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionGapEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * customer_theme | request_document | touchpoint | sme_note | prior_material | pp_evidence | teammate_evidence | attachment
   *
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 3;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_label = 4;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string excerpt = 5;
   */ _define_property(this, "excerpt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionGapEvidence, "runtime", proto3);
_define_property(CaptureSolutionGapEvidence, "typeName", "mono.projectdata.v1.CaptureSolutionGapEvidence");
_define_property(CaptureSolutionGapEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionGap
 */ export class CaptureSolutionGap extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionGap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionGap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionGap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionGap, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * requirement | capability | staffing
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * Optional CaptureSolutionItem id this gap is against.
   *
   * @generated from field: string solution_item_id = 4;
   */ _define_property(this, "solutionItemId", ""), /**
   * none | teaming | pp_data_call | task | customer_question | new_follow_up
   *
   * @generated from field: string follow_up_kind = 5;
   */ _define_property(this, "followUpKind", ""), /**
   * @generated from field: string follow_up_ref = 6;
   */ _define_property(this, "followUpRef", ""), /**
   * @generated from field: string follow_up_label = 7;
   */ _define_property(this, "followUpLabel", ""), /**
   * open | resolved
   *
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string resolution_note = 9;
   */ _define_property(this, "resolutionNote", ""), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 10;
   */ _define_property(this, "resolvedAt", void 0), /**
   * Resolving a gap never changes this.
   *
   * @generated from field: string assumption_validation = 11;
   */ _define_property(this, "assumptionValidation", ""), /**
   * @generated from field: string actor_user_id = 12;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * At least one at creation.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionGapEvidence evidence = 14;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionGap, "runtime", proto3);
_define_property(CaptureSolutionGap, "typeName", "mono.projectdata.v1.CaptureSolutionGap");
_define_property(CaptureSolutionGap, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solution_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "follow_up_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "follow_up_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "follow_up_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "resolution_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "assumption_validation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "evidence",
            kind: "message",
            T: CaptureSolutionGapEvidence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionAlternativesRequest
 */ export class GetCaptureSolutionAlternativesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionAlternativesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionAlternativesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionAlternativesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionAlternativesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionAlternativesRequest, "runtime", proto3);
_define_property(GetCaptureSolutionAlternativesRequest, "typeName", "mono.projectdata.v1.GetCaptureSolutionAlternativesRequest");
_define_property(GetCaptureSolutionAlternativesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionAlternativesResponse
 */ export class GetCaptureSolutionAlternativesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionAlternativesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionAlternativesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionAlternativesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionAlternativesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionAlternative alternatives = 1;
   */ _define_property(this, "alternatives", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionGap gaps = 2;
   */ _define_property(this, "gaps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionAlternativesResponse, "runtime", proto3);
_define_property(GetCaptureSolutionAlternativesResponse, "typeName", "mono.projectdata.v1.GetCaptureSolutionAlternativesResponse");
_define_property(GetCaptureSolutionAlternativesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alternatives",
            kind: "message",
            T: CaptureSolutionAlternative,
            repeated: true
        },
        {
            no: 2,
            name: "gaps",
            kind: "message",
            T: CaptureSolutionGap,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureSolutionAlternativeRequest
 */ export class AddCaptureSolutionAlternativeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureSolutionAlternativeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureSolutionAlternativeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureSolutionAlternativeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureSolutionAlternativeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionAlternative alternative = 4;
   */ _define_property(this, "alternative", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureSolutionAlternativeRequest, "runtime", proto3);
_define_property(AddCaptureSolutionAlternativeRequest, "typeName", "mono.projectdata.v1.AddCaptureSolutionAlternativeRequest");
_define_property(AddCaptureSolutionAlternativeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "alternative",
            kind: "message",
            T: CaptureSolutionAlternative
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureSolutionAlternativeResponse
 */ export class AddCaptureSolutionAlternativeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureSolutionAlternativeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureSolutionAlternativeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureSolutionAlternativeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureSolutionAlternativeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionAlternative alternative = 1;
   */ _define_property(this, "alternative", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureSolutionAlternativeResponse, "runtime", proto3);
_define_property(AddCaptureSolutionAlternativeResponse, "typeName", "mono.projectdata.v1.AddCaptureSolutionAlternativeResponse");
_define_property(AddCaptureSolutionAlternativeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alternative",
            kind: "message",
            T: CaptureSolutionAlternative
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideCaptureSolutionAlternativeRequest
 */ export class DecideCaptureSolutionAlternativeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionAlternativeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionAlternativeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionAlternativeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionAlternativeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string alternative_id = 4;
   */ _define_property(this, "alternativeId", ""), /**
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionAlternativeRequest, "runtime", proto3);
_define_property(DecideCaptureSolutionAlternativeRequest, "typeName", "mono.projectdata.v1.DecideCaptureSolutionAlternativeRequest");
_define_property(DecideCaptureSolutionAlternativeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "alternative_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideCaptureSolutionAlternativeResponse
 */ export class DecideCaptureSolutionAlternativeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionAlternativeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionAlternativeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionAlternativeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionAlternativeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionAlternative alternative = 1;
   */ _define_property(this, "alternative", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionAlternativeResponse, "runtime", proto3);
_define_property(DecideCaptureSolutionAlternativeResponse, "typeName", "mono.projectdata.v1.DecideCaptureSolutionAlternativeResponse");
_define_property(DecideCaptureSolutionAlternativeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alternative",
            kind: "message",
            T: CaptureSolutionAlternative
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureSolutionGapRequest
 */ export class AddCaptureSolutionGapRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureSolutionGapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureSolutionGapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureSolutionGapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureSolutionGapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionGap gap = 4;
   */ _define_property(this, "gap", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureSolutionGapRequest, "runtime", proto3);
_define_property(AddCaptureSolutionGapRequest, "typeName", "mono.projectdata.v1.AddCaptureSolutionGapRequest");
_define_property(AddCaptureSolutionGapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "gap",
            kind: "message",
            T: CaptureSolutionGap
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureSolutionGapResponse
 */ export class AddCaptureSolutionGapResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureSolutionGapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureSolutionGapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureSolutionGapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureSolutionGapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionGap gap = 1;
   */ _define_property(this, "gap", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureSolutionGapResponse, "runtime", proto3);
_define_property(AddCaptureSolutionGapResponse, "typeName", "mono.projectdata.v1.AddCaptureSolutionGapResponse");
_define_property(AddCaptureSolutionGapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gap",
            kind: "message",
            T: CaptureSolutionGap
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveCaptureSolutionGapRequest
 */ export class ResolveCaptureSolutionGapRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveCaptureSolutionGapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveCaptureSolutionGapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveCaptureSolutionGapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveCaptureSolutionGapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string gap_id = 3;
   */ _define_property(this, "gapId", ""), /**
   * @generated from field: string resolution_note = 4;
   */ _define_property(this, "resolutionNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveCaptureSolutionGapRequest, "runtime", proto3);
_define_property(ResolveCaptureSolutionGapRequest, "typeName", "mono.projectdata.v1.ResolveCaptureSolutionGapRequest");
_define_property(ResolveCaptureSolutionGapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "gap_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "resolution_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveCaptureSolutionGapResponse
 */ export class ResolveCaptureSolutionGapResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveCaptureSolutionGapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveCaptureSolutionGapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveCaptureSolutionGapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveCaptureSolutionGapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionGap gap = 1;
   */ _define_property(this, "gap", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveCaptureSolutionGapResponse, "runtime", proto3);
_define_property(ResolveCaptureSolutionGapResponse, "typeName", "mono.projectdata.v1.ResolveCaptureSolutionGapResponse");
_define_property(ResolveCaptureSolutionGapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gap",
            kind: "message",
            T: CaptureSolutionGap
        }
    ]));
